<template>
  <div class="data-table">
    <FilterContainer>
      <BaseElInput
        v-model="search.code"
        :placeholder="$t('member.tab.memberShopOrderRecord.searchPlaceholder')"
        clearable
        @clear="refresh(true)"
        @keypress.enter.native="refresh(true)"
      >
        <i
          slot="suffix"
          class="el-input__icon el-icon-search"
          @click="refresh(true)"
        />
      </BaseElInput>
      <BaseElSelect
        v-if="checkAction('planModule.cyjPos.enable')"
        v-model="search.isCyjPosDepositCreated"
        clearable
        placeholder="CYJ POS 建立"
        @change="refresh(true)"
        @clear="refresh(true)"
      >
        <BaseElSelectOption label="是" :value="true" />
        <BaseElSelectOption label="否" :value="false" />
      </BaseElSelect>
    </FilterContainer>
    <BaseTable v-loading="loading.table" :data="displayData">
      <EmptyBlock slot="empty" />
      <BaseElTableColumn :label="$t('member.tab.memberShopOrderRecord.orderCode')" prop="code" align="center" />
      <BaseElTableColumn :label="$t('member.tab.memberShopOrderRecord.orderDate')" prop="createdAt" align="center" />
      <BaseElTableColumn
        v-if="checkAction('planModule.cyjPos.enable')"
        :label="$t('member.tab.memberShopOrderRecord.cyjPosStatus')"
        prop="cyjPosStatus"
        align="center"
      />
      <BaseElTableColumn :label="$t('member.tab.memberShopOrderRecord.paymentStatus')" align="center">
        <template slot-scope="scope">
          <Tag :type="get(scope.row, 'status.tagType')">
            {{ get(scope.row, 'status.label') }}
          </Tag>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('member.tab.memberShopOrderRecord.orderTotal')" prop="orderPrice" align="center" />
      <BaseElTableColumn :label="$t('member.tab.memberShopOrderRecord.paymentStatus')" align="center">
        <template slot-scope="scope">
          <Tag :type="get(scope.row, 'paymentStatus.tagType')">
            {{ get(scope.row, 'paymentStatus.label') }}
          </Tag>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('member.tab.memberShopOrderRecord.paymentType')" align="center">
        <template slot-scope="scope">
          {{ get(scope.row, 'paymentType.label') }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('member.common.action.text')" fixed="right" width="110" align="center">
        <template slot-scope="scope">
          <TableEditBtnGroup
            hideDelete
            :editBtn="$t('member.tab.memberShopOrderRecord.view')"
            @edit="onRowEdit(scope.row)"
          />
        </template>
      </BaseElTableColumn>
    </BaseTable>

    <Pagination
      :curPage.sync="tableOptions.page"
      :pageLimit="tableOptions.pageLimit"
      :total="tableDataCount"
      @pageChange="refresh(false)"
    />
  </div>
</template>

<script>
import { defineComponent, computed, onMounted } from 'vue'
import EmptyBlock from '@/components/EmptyBlock.vue'
import FilterContainer from '@/components/Container/FiltersContainer.vue'
import { GetMemberShopOrder, GetMemberShopOrderCount } from '@/api/memberShop'
import { useTable } from '@/use/table'
import { get, map } from 'lodash'
import { formatDate } from '@/utils/date'
import {
  orderStatusConfig,
  orderPaymentStatusConfig,
  orderPaymentTypeConfig,
} from '@/config/memberShop'
import { useRouter } from 'vue-router/composables'
import { usePermissions } from '@/use/permissions'
import { isCyjPosOrderCreated } from '@/utils/cyjPosOrder'

export default defineComponent({
  name: 'DataTable',
  components: { EmptyBlock, FilterContainer },
  props: ['memberId'],
  emits: ['refresh'],
  setup (props, { emit }) {
    const router = useRouter()
    const { checkAction } = usePermissions()
    const {
      shopId,
      loading,
      search,
      extendData,
      tableData,
      tableDataCount,
      tableOptions,
      pageStartIndex,
      selectRow,
    } = useTable()

    extendData('search', {
      code: null,
      isCyjPosDepositCreated: null,
    })

    const displayData = computed(() => {
      const data = tableData.value
      // handle data here
      // return data
      return map(data, (i) => {
        return {
          id: i.id,
          code: i.code,
          createdAt: formatDate(i.createdAt),
          cyjPosStatus: isCyjPosOrderCreated(get(i, 'MemberStoreOrderProducts')) ? 'POS建立' : '-',
          orderPrice: get(i, 'totalOriginalProductPrice') || 0,
          status: get(orderStatusConfig, i.status),
          paymentStatus: get(
            orderPaymentStatusConfig,
            get(i, 'MemberStoreOrderPayment.status'),
          ),
          paymentType: get(
            orderPaymentTypeConfig,
            get(i, 'MemberStoreOrderPayment.paymentType'),
          ),
        }
      })
    })

    const getData = async (payload) => {
      const [res, err] = await GetMemberShopOrder(payload)
      if (err) return window.$message.error(err)
      tableData.value = res
    }
    const getDataCount = async (payload) => {
      const [res, err] = await GetMemberShopOrderCount(payload)
      if (err) return window.$message.error(err)
      tableDataCount.value = res.count
    }

    const getTableData = async () => {
      const payload = {
        shopId: shopId.value,
        start: pageStartIndex.value,
        limit: tableOptions.pageLimit,
        code: search.code || undefined,
        MemberId: props.memberId,
        isCyjPosDepositCreated: search.isCyjPosDepositCreated === '' || search.isCyjPosDepositCreated === null
          ? undefined
          : search.isCyjPosDepositCreated,
      }
      await Promise.allSettled([getData(payload), getDataCount(payload)])
    }

    const refresh = async (search = false) => {
      if (search) tableOptions.page = 1
      loading.table = true
      await getTableData()
      loading.table = false
    }

    const onRowEdit = (row) => {
      router.push({
        name: 'MemberShopOrderDetail',
        params: {
          id: row.id,
        },
      })
    }

    onMounted(async () => {
      console.log('memberId', props.memberId)
      refresh()
    })

    return {
      get,
      search,
      loading,
      refresh,
      displayData,
      onRowEdit,
      tableOptions,
      tableDataCount,
      checkAction,
    }
  },
})
</script>
